export enum GridColumnType {
    Text = 'text',
    Number = 'number',
    Date = 'date',
    DateTime = 'datetime',
    NgbDate = 'ngbDate',
    Boolean = 'boolean',
    DDL = 'ddl',
    ZRC = 'zrc',
    CheckBox = 'checkbox'
}